import { gql } from "@apollo/client";

export const GET_COMPANION_SESSION = gql`
  query getCompanionSession($companionSessionUuid: String!) {
    companionSession(companionSessionUuid: $companionSessionUuid) {
      companionSessionUuid
      user {
        uuid
        firstName
        lastName
      }
      note {
        uuid
      }
      createdAt
      updatedAt
      status
      agentVersion
      inventory {
        inventoryUuid
        status
      }
      knowledge {
        knowledgeKey
        knowledgeValue
      }
      tasks {
        companionSessionTaskUuid
        name
        createdAt
        updatedAt
        status
        taskStepDescription
      }
      estimates {
        companionSessionEstimateUuid
        createdAt
        updatedAt
        items {
          companionSessionEstimateItemUuid
          quantity
          choices {
            inventoryItemUuid
            inventoryItem {
              productCode
              description
              priceCents
              dispensingFeeCents
            }
            isSelected
          }
        }
      }
    }
  }
`;
export default GET_COMPANION_SESSION;
